<template>
    <div class="col-md-auto text-right">
        <el-select
                v-model="location"
                placeholder="Standort wählen"
                @change="updateLocation"
                :disabled="role < 3"
              >
              <el-option v-for="location in locations"
                  :key="location.key"
                  :label="location.name"
                  :value="location.key"
                ></el-option>
        </el-select>
    </div>
</template>
<script>
  import Vue from "vue";
  import store from "../../../../store";
  import { Select, Option } from "element-ui";
  import locations from "../../../../locationStore";
  
  export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
    },
  
    data() {
      return {
        location: store.getters.userlocation,
        role: store.getters.userrole,
        locations: locations.getters.locations.locations,
      };
    },
    created() {
    },
    methods: {
        updateLocation() {
            this.$emit('locationChanged', this.location)
        }
    },
  };
</script>
<style>
</style>
  